<template>
    <div class="autoresponderPreview">
        <b-button @click="showPreview" :disabled="loading || disabled" :size="size">
            {{$t('button')}}
            <font-awesome-icon v-show="loading" spin
                    icon="spinner-third"></font-awesome-icon></b-button>
        <b-modal v-model="show">
            <b-container fluid class="autoresponderPreview">
                <b-row>
                    <b-col class="subject">
                        <label>{{$t('subject')}}:</label> {{subject}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="content" :class="{ htmlMode }">{{content}}</b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'autoresponderPreview',
  components: { FontAwesomeIcon },
  i18nOptions: { keyPrefix: 'settings.autoresponders.preview' },
  data: function() {
    return {
      show: false,
      subject: '',
      content: '',
      loading: false,
      htmlMode: false
    };
  },
  props: {
    autoresponder: Object,
    rule: Object,
    disabled: Boolean,
    size: {
      type: String,
      default: 'md'
    }
  },
  methods: {
    showPreview() {
      this.loading = true;
      this.subject = '';
      this.content = '';
      this.$RPC(`/settings/autoresponders`, 'preview', {
        autoresponder: this.autoresponder,
        rule: this.rule,
        originator: this.$t('exampleSender'),
        subject: this.$t('exampleSubject')
      })
        .then(d => {
          this.show = true;
          console.log(d);
          this.subject = d.subjectPreview;
          this.content = d.messagePreview;
          this.htmlMode = (this.content.substr(0, 5).toUpperCase() === '<HTML');
        })
        .catch(e => {
          this.$dialog.alert(this.$t('loadError', { error: e.message }));
          this.show = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .autoresponderPreview {
        display: inline-block;
        .subject {
            background-color: $dark;
            color: $light;
            label {
                font-weight: bold;
            }
        }
        .content {
            white-space: pre-wrap;
            .htmlMode {
                white-space: normal;
            }
        }
    }

</style>
